import { render, staticRenderFns } from "./VizrtOverviewView.vue?vue&type=template&id=53c5ae64&scoped=true&"
import script from "./VizrtOverviewView.vue?vue&type=script&lang=js&"
export * from "./VizrtOverviewView.vue?vue&type=script&lang=js&"
import style0 from "./VizrtOverviewView.vue?vue&type=style&index=0&id=53c5ae64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c5ae64",
  null
  
)

export default component.exports